import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	audioPlayer: {
		outline: "none"
	}
})

export default useStyles
